import React from 'react';
import styled from 'styled-components';

const RoadmapContainer = styled.div`
  min-height: 100vh;
  background: #0a0e1a;
  background-image: 
    linear-gradient(rgba(0, 212, 255, 0.03) 1px, transparent 1px),
    linear-gradient(90deg, rgba(0, 212, 255, 0.03) 1px, transparent 1px);
  background-size: 50px 50px;
  padding: 80px 0;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: radial-gradient(circle at 20% 50%, rgba(255, 0, 0, 0.05) 0%, transparent 50%),
                radial-gradient(circle at 80% 50%, rgba(0, 255, 0, 0.05) 0%, transparent 50%);
    pointer-events: none;
  }
`;

const Container = styled.div`
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 20px;
  position: relative;
  z-index: 1;
`;

const Title = styled.h1`
  font-size: 2.5rem;
  font-weight: 600;
  text-align: center;
  margin-bottom: 1rem;
  color: #fff;
  font-family: 'Courier New', monospace;
  text-transform: uppercase;
  letter-spacing: 3px;
  position: relative;
  
  &::after {
    content: '';
    display: block;
    width: 100px;
    height: 3px;
    background: linear-gradient(90deg, transparent, #00ff00, transparent);
    margin: 15px auto;
  }
`;

const Subtitle = styled.p`
  font-size: 1rem;
  text-align: center;
  margin-bottom: 4rem;
  color: rgba(0, 212, 255, 0.8);
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
  font-family: 'Courier New', monospace;
  text-transform: uppercase;
  letter-spacing: 1px;
`;

const StageContainer = styled.div`
  margin-bottom: 5rem;
  border: 1px solid rgba(0, 212, 255, 0.2);
  background: rgba(10, 14, 26, 0.8);
  backdrop-filter: blur(5px);
  padding: 30px;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 4px;
    height: 100%;
    background: linear-gradient(180deg, #ffaa00, #00ff00);
  }
`;

const StageTitle = styled.h2`
  font-size: 1.5rem;
  font-weight: 600;
  color: #00d4ff;
  margin-bottom: 2rem;
  font-family: 'Courier New', monospace;
  text-transform: uppercase;
  letter-spacing: 2px;
  display: flex;
  align-items: center;
  gap: 15px;

  &::before {
    content: '▶';
    color: #00ff00;
    font-size: 0.8rem;
  }
`;

const TasksGrid = styled.div`
  display: grid;
  gap: 15px;
  grid-template-columns: repeat(auto-fit, minmax(450px, 1fr));
`;

const TaskCard = styled.div`
  background: rgba(0, 0, 0, 0.6);
  border: 1px solid rgba(0, 212, 255, 0.3);
  border-left: 4px solid ${props => {
    switch(props.priority) {
      case 'Высокий': return '#ffaa00';
      case 'Средний': return '#ffaa00';
      default: return '#00ff00';
    }
  }};
  padding: 20px;
  transition: all 0.3s ease;
  position: relative;
  font-family: 'Courier New', monospace;

  &:hover {
    background: rgba(0, 0, 0, 0.8);
    border-color: rgba(0, 212, 255, 0.6);
    box-shadow: 0 0 20px rgba(0, 212, 255, 0.2);
    transform: translateX(5px);
  }

  &::before {
    content: ${props => `'RULE #${props.number}'`};
    position: absolute;
    top: -10px;
    left: 15px;
    background: #0a0e1a;
    padding: 0 10px;
    font-size: 0.7rem;
    color: rgba(0, 212, 255, 0.6);
    letter-spacing: 1px;
  }
`;

const TaskHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
  margin-bottom: 15px;
  padding-bottom: 10px;
  border-bottom: 1px solid rgba(0, 212, 255, 0.2);
`;

const TaskNumber = styled.div`
  background: rgba(0, 212, 255, 0.2);
  color: #00d4ff;
  width: 35px;
  height: 35px;
  border: 1px solid rgba(0, 212, 255, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 0.9rem;
  font-family: 'Courier New', monospace;
`;

const TaskTitle = styled.h3`
  font-size: 1.1rem;
  font-weight: 600;
  color: #fff;
  flex: 1;
  font-family: 'Courier New', monospace;
  line-height: 1.4;
`;

const TaskDescription = styled.p`
  font-size: 0.9rem;
  color: rgba(255, 255, 255, 0.7);
  line-height: 1.6;
  margin-bottom: 15px;
  font-family: 'Courier New', monospace;
`;

const TaskFooter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 15px;
  padding-top: 10px;
  border-top: 1px solid rgba(0, 212, 255, 0.1);
`;

const PriorityBadge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 5px 12px;
  border: 1px solid;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1px;
  font-family: 'Courier New', monospace;
  
  ${props => {
    switch(props.priority) {
      case 'Высокий':
        return `
          background: rgba(255, 170, 0, 0.1);
          color: #ffaa00;
          border-color: #ffaa00;
          box-shadow: 0 0 10px rgba(255, 170, 0, 0.3);
          
          &::before {
            content: '⚠';
            font-size: 0.7rem;
          }
        `;
      case 'Средний':
        return `
          background: rgba(255, 170, 0, 0.1);
          color: #ffaa00;
          border-color: #ffaa00;
          box-shadow: 0 0 10px rgba(255, 170, 0, 0.3);
          
          &::before {
            content: '🟡';
            font-size: 0.7rem;
          }
        `;
      default:
        return `
          background: rgba(0, 255, 0, 0.1);
          color: #00ff00;
          border-color: #00ff00;
          box-shadow: 0 0 10px rgba(0, 255, 0, 0.3);
          
          &::before {
            content: '🟢';
            font-size: 0.7rem;
          }
        `;
    }
  }}
`;

const StatusIndicator = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 0.7rem;
  color: rgba(0, 212, 255, 0.6);
  font-family: 'Courier New', monospace;
  
  &::before {
    content: '';
    width: 8px;
    height: 8px;
    background: #00ff00;
    border-radius: 50%;
    box-shadow: 0 0 10px #00ff00;
    animation: pulse 2s infinite;
  }
  
  @keyframes pulse {
    0%, 100% { opacity: 1; }
    50% { opacity: 0.5; }
  }
`;

const BackButton = styled.button`
  position: fixed;
  top: 30px;
  left: 30px;
  background: rgba(0, 0, 0, 0.8);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(0, 212, 255, 0.4);
  border-left: 3px solid #00d4ff;
  color: #00d4ff;
  padding: 10px 18px;
  cursor: pointer;
  font-size: 0.9rem;
  font-family: 'Courier New', monospace;
  text-transform: uppercase;
  letter-spacing: 1px;
  transition: all 0.3s ease;
  z-index: 1000;
  display: flex;
  align-items: center;
  gap: 8px;

  &::before {
    content: '◄';
    color: #00ff00;
  }

  &:hover {
    background: rgba(0, 212, 255, 0.1);
    border-color: #00d4ff;
    box-shadow: 0 0 15px rgba(0, 212, 255, 0.3);
    transform: translateX(-3px);
  }
`;

const Roadmap = () => {
  const roadmapData = [
    {
      stage: "Краткосрочный (1-3 месяца)",
      tasks: [
        {
          number: 1,
          title: "Подписание схем разным персоналом перед применением",
          description: "Внедрить workflow для утверждения схем сетевых взаимодействий (графов) разными ролями пользователей (администраторы, офицеры безопасности). Это обеспечит контроль перед применением политик, интегрируя с модулем \"Наблюдение и Контроль\".",
          priority: "Высокий"
        },
        {
          number: 2,
          title: "Проверка удаленных портов между хост-агентами",
          description: "Добавить функцию автоматической проверки и мониторинга удаленных портов между ХА (Host Agents) для выявления несанкционированных связей.",
          priority: "Высокий"
        },
        {
          number: 13,
          title: "Неудобно сортировать",
          description: "Улучшить сортировку в интерфейсе (таблицы, графы): добавить фильтры по дате, типу, статусу.",
          priority: "Средний"
        }
      ]
    },
    {
      stage: "Среднесрочный (3-6 месяцев)",
      tasks: [
        {
          number: 3,
          title: "Добавление FW на карту + управление ими",
          description: "Интегрировать отображение firewall (FW) на граф сетевых взаимодействий, с возможностью управления (блокировка/разрешение) напрямую из интерфейса.",
          priority: "Высокий"
        },
        {
          number: 4,
          title: "Анализ правил FW аппаратных",
          description: "Добавить модуль для анализа и импорта правил аппаратных FW, с визуализацией на графе и выявлением конфликтов.",
          priority: "Высокий"
        },
        {
          number: 5,
          title: "Суточный рапорт + отчеты",
          description: "Внедрить генерацию ежедневных отчетов (рапорт) о сетевых потоках, аномалиях и статусе, с экспортом в PDF/CSV.",
          priority: "Средний"
        },
        {
          number: 6,
          title: "Анализ приложений + вывод профиля приложения",
          description: "Разработать анализ приложений: сбор данных о трафике, создание профилей (нормальное поведение), вывод в интерфейсе.",
          priority: "Высокий"
        },
        {
          number: 7,
          title: "VLAN - проверить отображение на портах (расшифровка VLAN)",
          description: "Добавить отображение и расшифровку VLAN на портах в графе, с проверкой соответствия.",
          priority: "Средний"
        },
        {
          number: 8,
          title: "Динамика + контроль",
          description: "Улучшить динамический мониторинг: реал-тайм обновление графа, контроль изменений (новые связи выделяются).",
          priority: "Высокий"
        },
        {
          number: 9,
          title: "Работа с шаблонами",
          description: "Внедрить шаблоны для политик безопасности, групп и правил, с возможностью импорта/экспорта.",
          priority: "Средний"
        },
        {
          number: 10,
          title: "Превентивный анализ (Preventive analysis)",
          description: "Добавить превентивный анализ: моделирование атак (Lateral Movements) и штормов запросов на основе данных обучения.",
          priority: "Высокий"
        },
        {
          number: 11,
          title: "Выгрузка правил на внешние устройства",
          description: "Реализовать экспорт правил в форматы для внешних устройств (FW, оркестраторы).",
          priority: "Средний"
        }
      ]
    },
    {
      stage: "Долгосрочный (6+ месяцев)",
      tasks: [
        {
          number: 12,
          title: "Интеграция с oVirt / VMware",
          description: "Интегрировать с системами виртуализации oVirt и VMware для мониторинга и контроля в гибридных средах.",
          priority: "Высокий"
        },
        {
          number: 13,
          title: "Работа глубокая с приложениями",
          description: "Углубленный анализ приложений: профилирование на уровне процессов, интеграция с deep flow inspection.",
          priority: "Высокий"
        },
        {
          number: 14,
          title: "Интеграция уровня Docker (карты)",
          description: "Добавить поддержку Docker: визуализация контейнеров на графе, карты взаимодействий.",
          priority: "Высокий"
        },
        {
          number: 15,
          title: "Интеграция с Мониторингом",
          description: "Интегрировать с E-node monitoring",
          priority: "Средний"
        },
        {
          number: 16,
          title: "Workflow (заявки/ТО/операционное обслуживание)",
          description: "Внедрить workflow для заявок, технического обслуживания (ТО) и операций: автоматизация утверждений, логи.",
          priority: "Высокий"
        },
        {
          number: 17,
          title: "Загрузка карты действий + AI/инструкций",
          description: "Добавить загрузку карт действий с АІ-поддержкой: автоматизированные инструкции на основе обучения модели.",
          priority: "Высокий"
        },
        {
          number: 18,
          title: "SD-WAN + SDN для систем виртуализации",
          description: "Интегрировать SD-WAN и SDN для оптимизации трафика в виртуализованных средах, с контролем потоков.",
          priority: "Средний"
        }
      ]
    }
  ];

  const handleBackClick = () => {
    window.history.back();
  };

  return (
    <RoadmapContainer>
      <BackButton onClick={handleBackClick}>
        НАЗАД
      </BackButton>
      
      <Container>
        <Title>План развития</Title>
        <Subtitle>
          Стратегический план развития платформы E-node с приоритизацией задач по временным периодам
        </Subtitle>

        {roadmapData.map((stage, stageIndex) => (
          <StageContainer key={stageIndex}>
            <StageTitle>{stage.stage}</StageTitle>
            <TasksGrid>
              {stage.tasks.map((task, taskIndex) => (
                <TaskCard key={taskIndex} priority={task.priority} number={task.number}>
                  <TaskHeader>
                    <TaskNumber>{task.number}</TaskNumber>
                    <TaskTitle>{task.title}</TaskTitle>
                  </TaskHeader>
                  <TaskDescription>{task.description}</TaskDescription>
                  <TaskFooter>
                    <PriorityBadge priority={task.priority}>
                      {task.priority}
                    </PriorityBadge>
                    <StatusIndicator>ACTIVE</StatusIndicator>
                  </TaskFooter>
                </TaskCard>
              ))}
            </TasksGrid>
          </StageContainer>
        ))}
      </Container>
    </RoadmapContainer>
  );
};

export default Roadmap;
